import React from 'react'
import { Section } from '@shared/components/section'

import styles from './style.module.scss'

interface StepProps {
	id: number
	text: string
	Icon: any
}

interface Props {
	stepsPartnersList: StepProps[]
}

const Step = ({ text, Icon }: StepProps) => (
	<div className={styles.step}>
		<Icon className={styles.svg} />
		<span className={styles.text}>{text}</span>
	</div>
)

export const View = ({ stepsPartnersList }: Props) => (
	<Section className={styles.wrapper}>
		<div className={styles.content}>
			<h2 className={styles.title}>Партнёрство в три шага</h2>
			<div className={styles.steps}>
				{stepsPartnersList.map((step) => (
					<Step key={step.id} {...step} />
				))}
			</div>
		</div>
	</Section>
)
